import { createContext, useContext } from 'react';

import type { IRealmProfileSnapshot } from './types';

export type RealmProfileSource = 'default' | 'preview' | 'published' | 'unavailable';

export interface IRealmProfileContextValue {
  loading: boolean;
  profile?: IRealmProfileSnapshot;
  source: RealmProfileSource;
  /** retry 重新读取当前站点 Realm，失败时仍按远端 default Realm 降级。 */
  retry: () => void;
}

export const RealmProfileContext = createContext<IRealmProfileContextValue | null>(null);

/** useRealmProfile 读取 AppShell 注入的当前渠道配置。 */
export function useRealmProfile(): IRealmProfileContextValue {
  const value = useContext(RealmProfileContext);
  if (!value) throw new Error('RealmProfileContext is unavailable');
  return value;
}

/** useOptionalRealmProfile 允许标题等基础组件在独立测试中回退到原有品牌。 */
export function useOptionalRealmProfile(): IRealmProfileContextValue | null {
  return useContext(RealmProfileContext);
}
